import { Dialog, DialogContent } from "@/components/ui/dialog";
import { deletePost, IPost } from "@/lib/community";
import { useRef, useState } from "react";
import PostContent from "./PostContent";

import { useQueryClient } from "@tanstack/react-query";

interface PostModalProps {
  post: IPost;
  onClose: () => void;
  onUpdate: (post: IPost) => void;
  setSelectedPostToNull?: () => void;
}

export default function PostModal({
  post,
  onClose,
  onUpdate,
  setSelectedPostToNull,
}: PostModalProps) {
  const dialogContentRef = useRef<HTMLDivElement>(null);
  const queryClient = useQueryClient();
  const handleDeletePost = async (id: string) => {
    await deletePost(id);

    queryClient.invalidateQueries({ queryKey: ["posts"] });
    queryClient.invalidateQueries({ queryKey: ["user-posts"] });
    setSelectedPostToNull();
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent
        ref={dialogContentRef}
        className="max-w-2xl w-full p-0 bg-background border md:rounded-xl shadow-xl max-h-full md:max-h-[90vh] overflow-y-auto"
      >
        <div className="p-2 md:p-6 space-y-6">
          <PostContent
            post={post}
            scrollContainerRef={dialogContentRef}
            onUpdate={onUpdate}
            onDelete={handleDeletePost}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
